export const projects = [
  {
    id: 0,
    title: "Formpilot | AI-Powered Fitness Analytics Platform",
    description:
      "Designed and developed a scalable microservices-based application that leverages Generative AI to provide actionable fitness insights. The platform analyzes user activity data to offer personalized technique improvements, safety precautions, and performance suggestions.",
    details: [
      "Microservices Architecture: Decomposed the application into independent services using Java Spring Boot, orchestrated via Netflix Eureka for service discovery and an API Gateway.",
      "Scalable Event Streaming: Leveraged Spring Cloud Stream with Apache Kafka to facilitate high-throughput, fault-tolerant event-driven workflows.",
      "Advanced Security: Architected a centralized identity management system using Keycloak, implementing OAuth2 with PKCE and JWT.",
      "AI Integration: Integrated Google Gemini API to process structured fitness data and generate natural language recommendations.",
      "Polyglot Persistence: Utilized PostgreSQL for relational data and MongoDB for flexible, document-based storage.",
      "Modern Frontend: Built a responsive UI with React, managing complex application state with Redux and ensuring secure API consumptions."
    ],
    image: "/FormPilot.png",
    techStack: [
      "Java",
      "Spring Boot",
      "Microservices",
      "Netflix Eureka",
      "API Gateway",
      "Spring Cloud Stream",
      "Apache Kafka",
      "Keycloak",
      "Google Gemini API",
      "PostgreSQL",
      "MongoDB",
      "React",
      "Redux",
    ],
    liveUrl: null,
    githubUrl: "https://github.com/ManurangaJay/FormPilot",
  },
  {
    id: 1,
    title: "Bidflare - Online Bidding Platform",
    description:
      "Designed and engineered a scalable, full-stack auction platform delivering real-time bidding capabilities and secure transaction handling. This project demonstrates end-to-end software delivery, from architectural design and database optimization to automated cloud deployment.",
    details: [
      "Engineered a live notification system using WebSockets (SockJS/STOMP) to push instant bid updates and alerts.",
      "Containerized the entire stack with Docker and deployed to a production environment on AWS EC2.",
      "Established a fully automated CI/CD pipeline using GitHub Actions for testing and deployment.",
      "Optimized PostgreSQL database performance with strategic indexing on high-traffic columns.",
      "Implemented robust security with Spring Security, JWT, and Role-Based Access Control (RBAC).",
      "Integrated Stripe API (Test Mode) for secure payment processing workflows.",
      "Developed a responsive frontend with Next.js, Redux, and Tailwind CSS."
    ],
    image: "/Bidflare.png",
    techStack: [
      "Java",
      "Spring Boot",
      "Next.js",
      "TypeScript",
      "Redux",
      "PostgreSQL",
      "Docker",
      "AWS (EC2)",
      "GitHub Actions",
      "WebSockets",
      "Stripe API",
      "Spring Security",
      "JWT",
      "Tailwind CSS",
    ],
    liveUrl: null,
    githubUrl: "https://github.com/ManurangaJay/Bidflare-Monorepo",
  },
  {
    id: 2,
    title: "BlitzScale | High-Concurrency Flash Sale Engine",
    description: "Architected a highly concurrent, event-driven microservices platform designed to gracefully handle massive traffic spikes during e-commerce flash sales. The system eliminates database deadlocks and race conditions by decoupling immediate user requests from heavy database writes using asynchronous messaging and distributed caching.",
    details: [
      "Event-Driven Architecture: Built an independent microservices ecosystem using Java Spring Boot, orchestrated via Netflix Eureka for service discovery and Spring Cloud Gateway for centralized routing.",
      "High-Concurrency Handling: Engineered a resilient checkout mechanism utilizing Redis for distributed rate-limiting (Token Bucket) and sub-millisecond atomic stock locking to prevent overselling.",
      "Asynchronous Processing: Integrated Apache Kafka to transition from synchronous HTTP calls to asynchronous event streaming, acting as a massive shock absorber for downstream PostgreSQL and H2 databases.",
      "Centralized Security: Secured the API Gateway and underlying services using Keycloak for identity management, enforcing OAuth2 and JWT standards.",
      "Real-Time Observability: Implemented comprehensive system monitoring using Spring Boot Actuator, Prometheus, and Grafana to track JVM memory, CPU load, and API latency in real-time.",
      "Performance Benchmarking: Stress-tested the system using k6, successfully processing 39,300+ orders in 50 seconds (760+ TPS) with a 0.00% failure rate under local hardware constraints."
    ],
    image: "/BlitzScale.jpg",
    techStack: [
      "Java",
      "Spring Boot",
      "Microservices",
      "Spring Cloud Gateway",
      "Netflix Eureka",
      "Apache Kafka",
      "Redis",
      "Keycloak",
      "PostgreSQL",
      "Prometheus",
      "Grafana",
      "k6",
      "Docker"
    ],
    liveUrl: null,
    githubUrl: "https://github.com/ManurangaJay/BlitzScale",
  },
  {
    id: 3,
    title: "Student Log - Management System",
    description:
      "Built a full-stack student management system with CRUD functionality and responsive interface. Improved data management and user experience using modern web technologies.",
    details: [
      "Complete CRUD operations for student records.",
      "Intuitive user interface for easy navigation and data entry.",
      "Secure login system for administrators.",
      "Reporting features to generate student performance summaries.",
      "Database optimization for fast data retrieval.",
      "RESTful API architecture for seamless frontend-backend communication."
    ],
    image: "/student_log.png",
    techStack: [
      "Java Spring Boot",
      "React.js",
      "MySQL",
      "Postman",
      "GitHub",
      "Full Stack",
    ],
    liveUrl: null,
    githubUrl: "https://github.com/ManurangaJay/Student-Log",
  },
  {
    id: 4,
    title: "Automated Image Captioning System",
    description:
      "Developed and evaluated two deep-learning models (VGG16-LSTM and ResNet50-Transformer) for generating captions from images. Trained on 8,091 images with human-generated captions.",
    details: [
      "Implemented VGG16-LSTM and ResNet50-Transformer architectures.",
      "Pre-processing pipeline for resizing and normalizing images.",
      "Tokenization and embedding of captions for model training.",
      "Evaluation using BLEU scores to measure caption quality.",
      "Interactive web interface for uploading images and generating captions.",
      "Comparative analysis of model performance and accuracy."
    ],
    image: "/image_caption_generator.png",
    techStack: [
      "Python",
      "Deep Learning",
      "VGG16",
      "LSTM",
      "ResNet50",
      "Transformer",
      "TensorFlow",
      "PyTorch",
      "Computer Vision",
    ],
    liveUrl: null,
    githubUrl: "https://github.com/ManurangaJay/Image-Caption-Generator",
  },
  {
    id: 5,
    title: "JobHub - Job Listings API",
    description:
      "Built a REST API for job listings, companies, and reviews with Docker and PostgreSQL. Gained experience in microservices architecture with ongoing frontend integration.",
    details: [
      "RESTful API endpoints for jobs, companies, and reviews.",
      "Dockerized application for consistent deployment environments.",
      "Microservices architecture design principles.",
      "Comprehensive documentation using Swagger UI.",
      "Unit and integration testing for robust code.",
      "Scalable database schema design using PostgreSQL."
    ],
    image: "/Jobhub.png",
    techStack: [
      "Spring Boot",
      "Spring Boot MVC",
      "JPA",
      "H2",
      "PostgreSQL",
      "Docker",
      "Spring Boot Actuator",
    ],
    liveUrl: null,
    githubUrl: "#",
  },
  {
    id: 6,
    title: "CinemaSphere - Movie Review App",
    description:
      "Built a movie review app with decoupled architecture for scalable client-server interaction. Gained experience in full-stack development with modern technologies.",
    details: [
      "Decoupled client-server architecture for better scalability.",
      "User reviews and ratings system for movies.",
      "Integration with external movie databases for metadata.",
      "Responsive frontend built with React and Bootstrap.",
      "Efficient data storage and retrieval using MongoDB.",
      "Secure API endpoints for data access."
    ],
    image: "/CinemaSphere.png",
    techStack: [
      "MongoDB",
      "Java",
      "Spring Boot",
      "React",
      "Bootstrap",
      "Postman",
      "Full Stack",
    ],
    liveUrl: null,
    githubUrl: "https://github.com/ManurangaJay/CinemaSphere",
  },
  {
    id: 7,
    title: "University Exam Hall Booking System",
    description:
      "Developed an Exam Hall Booking System with user management and Outlook integration. Contributed to frontend development using React.js and .NET integration.",
    details: [
      "User management system for administrators and staff.",
      "Integration with Outlook for calendar bookings.",
      "Real-time availability checking for exam halls.",
      "Automated email notifications for booking confirmations.",
      "Responsive dashboard for managing bookings.",
      "Conflict detection to prevent double bookings."
    ],
    image: "/Exam_Hall_Booking_System.png",
    techStack: [
      "HTML",
      "CSS",
      "JavaScript",
      "React.js",
      "Web API",
      "Bootstrap",
      "Jira",
      "Postman",
      "GitHub",
      "Figma",
    ],
    liveUrl: null,
    githubUrl: "https://github.com/ManurangaJay/ExamHallBookingSystem",
  },
  {
    id: 8,
    title: "Decentralized Vehicle History System",
    description:
      "Final Year Research Project: Developing a blockchain-based system for secure, tamper-proof vehicle history tracking, ensuring data immutability, traceability, and fraud prevention.",
    details: [
      "Blockchain-based ledger for immutable history records.",
      "Smart contracts for automating data entries and verification.",
      "Decentralized architecture to prevent single points of failure.",
      "Web3 integration for wallet connection and transaction signing.",
      "User-friendly interface for viewing vehicle history.",
      "Fraud prevention mechanisms through transparent data tracking."
    ],
    image: "/Vehicle_History_System.png",
    techStack: [
      "Blockchain",
      "Ethereum",
      "Smart Contracts",
      "Node.js",
      "React",
      "Web3.js",
    ],
    liveUrl: null,
    githubUrl: "https://github.com/ManurangaJay/Vehicle-History-Dapp",
  },
];
